var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2966)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF060A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7898 9.26111C20.0023 8.53399 18.913 7.42363 18.0257 6.63614L17.9732 6.59939C17.8859 6.52925 17.7874 6.47424 17.6819 6.43664C15.5425 6.03765 5.58603 4.17655 5.39178 4.20017C5.33736 4.2078 5.28533 4.22753 5.23954 4.25792L5.18966 4.2973C5.12825 4.35967 5.08161 4.43501 5.05316 4.51779L5.04004 4.55192V4.73829V4.76717C6.1609 7.88825 10.5866 18.1125 11.4581 20.5117C11.5106 20.6745 11.6103 20.9842 11.7967 21H11.8387C11.9384 21 12.3637 20.4382 12.3637 20.4382C12.3637 20.4382 19.9656 11.2193 20.7347 10.2376C20.8343 10.1167 20.9222 9.98659 20.9972 9.8491C21.0164 9.74153 21.0073 9.63083 20.971 9.52778C20.9346 9.42474 20.8722 9.33286 20.7898 9.26111ZM14.314 10.3347L17.5585 7.64413L19.4616 9.3976L14.314 10.3347ZM13.0541 10.1588L7.46813 5.58091L16.5059 7.24776L13.0541 10.1588ZM13.5581 11.3585L19.2752 10.4371L12.7391 18.312L13.5581 11.3585ZM6.70952 6.03765L12.5868 11.0251L11.7363 18.3172L6.70952 6.03765Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.8c9b89efbf7c14627ae5c92c18a7c94a.svg";
export { ForwardRef as ReactComponent };